export default __webpack_public_path__ + "static/media/vulkan.ba76083b.svg";